import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from './base.service';

@Injectable()
export class DataShareService extends BaseService {
  public reportPage: { lastReport: string };

  constructor(protected http: Http) {
    super(http);
    this.reportPage = { lastReport: null };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/data-share.service.ts